import Context from '../../provider';
import React, { useContext } from 'react';
import './index.scss';

export default function CardComponent(props) {
  const {
    cardBg,
    cardTitle,
    cardDesc,
    onClick,
    btnText,
    cardStyle = {},
    cardImgClass,
    contentClass,
    btn
  } = props;

  const { isMobile } = useContext(Context);

  return (
    <div className={`${isMobile ? 'mobile' : 'web'}-card`} style={cardStyle}>
      <div className={cardImgClass} style={{ backgroundImage: `url(${cardBg})` }} />
      <div className={contentClass}>
        <div className='item-text-cont'>
          <div className='item-text-title'>
            {cardTitle}
          </div>
          <div className='item-text-desc'>
            {cardDesc}
          </div>
        </div>
        {btn}
      </div>
  </div>
  );
}